<template>
  <!-- 后台管理模块父组件左侧组件库 -->
  <div class="sliderassembly">
    <div>
      <!-- 可切换新增模块和我的模块 -->
      <div class="module-switcher">
        <div
          class="switch-item"
          :class="{ active: currentModule === 'newModule' }"
          @click="switchModule('newModule')"
        >
          新增模块
        </div>
        <div
          class="switch-item"
          :class="{ active: currentModule === 'myModule' }"
          @click="switchModule('myModule')"
        >
          我的模块
        </div>
      </div>
    </div>
    <!-- 新增模块 -->
    <transition name="sidebar-slide">
      <div class="sidebar-container" v-show="currentModule === 'newModule'">
        <el-collapse v-model="activeNames">
          <el-collapse-item
            :title="items.title"
            :name="index + 1"
            v-for="(items, index) in datas"
            :key="index"
          >
            <div
              :style="{ cursor: draggable ? 'all-scroll' : 'pointer' }"
              class="componList"
              :draggable="draggable"
              @dragstart="drag($event, item,item.name)"
              @dragend="dragends($event)"
              :data-name="item.name"
              v-for="(item, ind) in items.comList"
              :key="ind"
            >
              <img :src="getIcon(item.icon)" alt="" style="max-height: 38px" />
              <!-- <img  src="@/assets/svg/build.svg" alt="" style="max-height: 38px;"> -->
              <!-- <i class="iconfont" :class="item.icon" v-if="item.icon" />
              <van-icon :name="item.icon" v-else /> -->
              <p>{{ item.text }}</p>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </transition>
    <transition name="sidebar-slide">
      <div class="sidebar-container" v-show="currentModule === 'myModule'">
        <!-- 我的模块 -->
        <div>
          <MyModule
            :datas="components"
            @componenmanagement="$emit('componenmanagement', $event)"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import AddModule from "../admin/modul/components/AddModule/AddModule.vue";
import componentProperties from "@/utils/componentProperties"; // 组件数据
// 引用我的模版组件

export default {
  name: "sliderassembly",
  props: {
    rightcom: String,
    pointer: Object,
    components: Array,
  },
  computed: {
    // 引用user模块的state
    ...mapState("modules", ["sliderNavbarList"]),
  },
  watch: {
    // 监听父组件传递过来的页面组件列表components变化
    components: {
      handler(newVal, oldVal) {
        console.log(
          "监听sliderassemably父组件传递过来的页面组件列表components变化------------------",
          newVal,
          oldVal,
          this.rightcom,
          this.components,
          this.pointer,
        );
        // switch (this.rightcom) {
        //   case "1-1":
        //     this.activeNames = [1];
        //     break;
        //   case "1-2":
        //     this.activeNames = [2];
        //     break;
        //   case "1-3":
        //     this.activeNames = [3];
        //     break;
        //   default:
        //     this.activeNames = [1, 2, 3];
        //     break;
        // }
      },
      deep: true,
    },
  },
  data() {
    return {
      pageComponents: Array.from(componentProperties.values()),
      draggable: true, //是否可以进行拖拽
      activeNames: [1, 2, 3] /* 侧边栏组件显示 */,
      currentModule: "newModule", // 默认选中新增模块
      datas: [
        // {
        //   title: "常用",
        //   comList: [
        //     {
        //       text: "标题文本",
        //       type: "1-1",
        //       icon: "icon-Component-biaotiwenzi",
        //       name: "captiontext",
        //       hidden: false,
        //     },
        //     {
        //       text: "商品搜索",
        //       type: "1-2",
        //       icon: "icon-shangpinsousuo",
        //       name: "commoditysearch",
        //       hidden: false,
        //     },
        //     {
        //       text: "标题栏",
        //       type: "1-3",
        //       icon: "icon-tupianguanggao",
        //       name: "titlebar",
        //       hidden: false,
        //     },
        //     {
        //       text: "图片广告",
        //       type: "1-4",
        //       icon: "icon-tupianguanggao",
        //       name: "pictureads",
        //       hidden: false,
        //     },
        //     {
        //       text: "图片+导航组",
        //       type: "1-5",
        //       icon: "icon-tupianguanggao",
        //       name: "picturenavgroup",
        //       hidden: false,
        //     },
        //     // {
        //     //   text: "图文导航",
        //     //   type: "1-6",
        //     //   icon: "icon-icon_tupiandaohang",
        //     //   name: "graphicnavigation",
        //     // },
        //     {
        //       text: "服务导航",
        //       type: "1-7",
        //       icon: "icon-tupianguanggao",
        //       name: "servicenavigation",
        //       hidden: false,
        //     },
        //     {
        //       text: "公告",
        //       type: "1-8",
        //       icon: "icon-gonggao",
        //       name: "notice",
        //       hidden: false,
        //     },
        //     {
        //       text: "底部导航",
        //       type: "1-5",
        //       icon: "icon-daohang",
        //       name: "tabbar",
        //       hidden: false,
        //     },
        //     // {
        //     //   text: "魔方",
        //     //   type: "1-6",
        //     //   icon: "icon-mofang",
        //     //   name: "magiccube",
        //     // },
        //     // {
        //     //   text: "视频",
        //     //   type: "1-8",
        //     //   icon: "icon-shipin",
        //     //   name: "videoss",
        //     // },
        //     // {
        //     //   text: "富文本",
        //     //   type: "1-10",
        //     //   icon: "icon-fuwenben",
        //     //   name: "richtext",
        //     // },
        //     // {
        //     //   text: "辅助分割",
        //     //   type: "1-11",
        //     //   icon: "icon-Component-fuzhufenge",
        //     //   name: "auxiliarysegmentation",
        //     // },
        //     // {
        //     //   text: "店铺信息",
        //     //   type: "1-12",
        //     //   icon: "icon-dianpuxinxi",
        //     //   name: "storeinformation",
        //     // },
        //     // {
        //     //   text: "单元格",
        //     //   type: "1-13",
        //     //   icon: "icon-jinrudianpu",
        //     //   name: "entertheshop",
        //     // },
        //     // {
        //     //   text: "社群涨粉",
        //     //   type: "1-14",
        //     //   icon: "icon-kuaisuzhangfen",
        //     //   name: "communitypowder",
        //     // },
        //     /* {
        //       text: 'xxx',
        //       type: '1-17',
        //       icon: 'icon-yunying',
        //       name: ''
        //     }, */
        //     /* {
        //       text: 'xxx',
        //       type: '1-19',
        //       icon: 'icon-weibiaoti-_huaban',
        //       name: ''
        //     }, */
        //     /* {
        //       text: 'xxxx',
        //       type: '1-18',
        //       icon: 'icon-gexinghuatuijian',
        //       name: ''
        //     }, */
        //     // {
        //     //   text: "关注公众号",
        //     //   type: "1-15",
        //     //   icon: "icon-gongzhonghao",
        //     //   name: "follow",
        //     // },
        //     // {
        //     //   text: "悬浮",
        //     //   type: "1-16",
        //     //   icon: "icon-wangye",
        //     //   name: "suspension",
        //     // },
        //     // {
        //     //   text: "自定义模块",
        //     //   type: "demo",
        //     //   icon: "icon-zidingyimokuai",
        //     //   name: "custommodule",
        //     // },
        //   ],
        // },
        // {
        //   title: "基础",
        //   comList: [
        //     {
        //       text: "文章列表",
        //       type: "3-1",
        //       icon: "icon-Component-biaotiwenzi",
        //       name: "storenotecard",
        //       hidden: false,
        //     },
        //   ],
        // },
        // {
        //   title: "排版",
        //   comList: [
        //     {
        //       text: "横向标签",
        //       type: "3-1",
        //       icon: "icon-Component-biaotiwenzi",
        //       name: "transversustag",
        //       hidden: false,
        //     },
        //   ],
        // },
        // {
        //   title: "互动",
        //   comList: [
        //     {
        //       text: "互动卡片",
        //       type: "4-1",
        //       icon: "icon-Component-biaotiwenzi",
        //       name: "interactioncard",
        //       hidden: false,
        //     },
        //   ],
        // },
      ],
    };
  },
  mounted() {},
  created() {
    console.log(
      "sliderassembly组件created挂载了----------------------------",
      this.components,
    );
    this.fetchCompanySliderNavbarList();
  },
  methods: {
    getIcon(icon) {
      console.log("打印icon", icon);
      if (icon !== '#') {
        return require(`@/assets/svg/${icon}.svg`);
      }
       return ""
    },
    addModule() {
      this.draggable = !this.draggable;
      console.log(
        "嗲用左侧的组件库了-----------------------------------------",
        this.draggable,
        this.$parent,
      );
    },
    /**
     * 从Vuex获取左侧导航栏列表数据
     */
    async fetchCompanySliderNavbarList() {
      const res = await this.$api.auth.getCompanyRoutersAPI({ menuId: 2079 });
      if (res.code == 200) {
        // 转换数据格式
        const newSliderNavbarList = this.$utils.transformListToData(res.data);
        newSliderNavbarList.forEach((item, index) => {
          item.comList.forEach((comItem, comIndex) => {
            this.pageComponents.forEach((component) => {
              if (component.component === comItem.name) {
                comItem.type = component.type;
              }
            });
            console.log("打印组件类型", comItem.type, comItem.text);
          });
        });
        console.log(
          "转换后的组件模块666666666666666666666666666666",
          res,
          newSliderNavbarList,
        );
        this.datas = newSliderNavbarList;
        // console.log("获取左侧组件库", this.datas);
        this.$store.commit("modules/setSliderNavbarList", newSliderNavbarList);
      } else {
        this.$store.commit("modules/setSliderNavbarList", []);
      }
    },
    /**
     * 切换模块
     * @param {String} moduleType 模块类型 'newModule' | 'myModule'
     */
    switchModule(moduleType) {
      this.currentModule = moduleType;
      // 这里可以根据需要加载不同模块的数据
      // 例如，当切换到'我的模块'时，可以调用API获取用户自定义的模块
      // 现在简单模拟一下数据切换效果
      if (moduleType === "myModule") {
        // 实际项目中这里可能会调用API获取用户的模块数据
        console.log("切换到我的模块");
      } else {
        console.log("切换到新增模块");
      }
    },

    /**
     * 当用户开始拖动元素或选择文本时触发此事件
     *
     * @param {Object} event event对象
     */
    drag(event, component, componentName) {
      /* 开启穿透 */
      this.pointer.show = true;
      // 使用原有的数据结构，不添加新字段
      const dragData = {
        name: component.name,
        type: component.type,
        text: component.text,
        icon: component.icon,
      };
      console.log("开始拖拽组件了", dragData);
      /* 传递参数 */
      event.dataTransfer.setData("componentName", componentName);
      console.log("开始拖拽组件了复制组件名称后", event,componentName);
    },

    /**
     * 当拖动操作结束时（释放鼠标按钮或按下退出键），会触发此事件
     *
     * @param {Object} event event对象
     */
    dragends() {
      /* 关闭穿透 */
      this.pointer.show = false;
      console.log("拖拽结束");
    },
  },
};
</script>
<style scoped lang="scss">
/* 左侧抽屉过渡动画 */
.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
  transition: all 0.3s ease;
}

.sidebar-slide-enter,
.sidebar-slide-leave-to {
  transform: translateX(-100%);
}
/* 组件 */
.sliderassembly {
  width: 275px;
  height: 100%;
  border: 2px solid red;
  overflow-y: scroll;
  border-right: 1px solid #ebedf0;
  box-sizing: border-box;
  padding: 0 12px;
  background: #fff;
  /* 滚动条 */
  &::-webkit-scrollbar {
    width: 1px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #155bd4;
  }
  ::v-deep.el-collapse-item__header,
  ::v-deep.el-collapse-item__wrap {
    border-bottom: 0 !important;
  }

  /* 模块切换导航栏 */
  .module-switcher {
    display: flex;
    margin: 16px 0;
    border-radius: 6px;
    overflow: hidden;
  }

  .switch-item {
    flex: 1;
    padding: 10px 0;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    color: #606266;
    position: relative;
  }

  .switch-item.active {
    color: #348cf8;
    font-weight: 500;
  }

  .switch-item:not(.active):hover {
    color: #348cf8;
  }

  /* 下划线动画效果 */
  .switch-item.active::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 2px;
    background: #348cf8;
    border-radius: 1px;
  }

  /* 组件列表 */
  .componList {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    width: 80px;
    height: 88px;
    margin-bottom: 8px;
    align-items: center;

    transition: all 0.3s;
    &:hover {
      background: #348cf8;
      border-radius: 2px;
      font-weight: 700;
      i,
      p,
      span {
        color: #fff;
      }
    }
    /* 图标 */
    i {
      font-size: 32px;
      width: 32px;
      height: 32px;
      line-height: 32px;
      color: #b0a8a8;
      margin-top: 4px;
    }
    /* 标题 */
    p {
      font-size: 12px;
      color: #323233;
      margin-top: 4px;
    }
    /* 数量 */
    span {
      color: #7d7e80;
      margin-top: 4px;
      font-size: 10px;
    }
  }
}
</style>
